import { useEffect, useRef, useState } from "react";
import { MapPin, Check, Loader2 } from "lucide-react";
import api from "../lib/api";

/**
 * Pencarian wilayah KiriminAja. Pembeli mengetik kelurahan & kecamatan,
 * lalu memilih satu dari daftar "Kelurahan, Kecamatan, Kota, Provinsi".
 * Kota & provinsi diambil dari pilihan itu (tidak diisi manual lagi).
 */
export const WilayahPicker = ({ nilai, onPilih, onSentuh, tid = "wilayah" }) => {
  const [q, setQ] = useState("");
  const [hasil, setHasil] = useState(null);
  const [memuat, setMemuat] = useState(false);
  const [buka, setBuka] = useState(false);
  const timer = useRef(null);

  useEffect(() => {
    if (timer.current) clearTimeout(timer.current);
    if (q.trim().length < 3) { setHasil(null); return; }
    timer.current = setTimeout(async () => {
      setMemuat(true);
      try {
        const { data } = await api.get("/api/wilayah/cari", { params: { q: q.trim(), limit: 10 }, timeout: 15000 });
        setHasil(data.hasil || []);
        setBuka(true);
      } catch {
        setHasil([]);
      } finally {
        setMemuat(false);
      }
    }, 450);
    return () => timer.current && clearTimeout(timer.current);
  }, [q]);

  const barisAtas = [nilai?.kelurahan, nilai?.kecamatan].filter(Boolean).join(", ");
  const barisBawah = [nilai?.ka_kota, nilai?.ka_provinsi].filter(Boolean).join(", ");

  return (
    <div data-testid={`${tid}-block`}>
      <label className="text-sm font-medium">
        Kelurahan &amp; Kecamatan <span className="text-red-500">*</span>
      </label>
      {nilai?.ka_label ? (
        <div className="mt-1 flex items-start gap-2 rounded-lg px-3 py-2"
          style={{ border: "1px solid #1F6B3A", backgroundColor: "#E8F5EC" }}>
          <Check size={16} className="mt-0.5 shrink-0" style={{ color: "#1F6B3A" }} />
          <div className="flex-1 text-sm">
            <div className="font-semibold text-stone-800" data-testid={`${tid}-terpilih`}>
              {barisAtas || nilai.ka_label}
            </div>
            {barisBawah && <div className="text-xs text-stone-500" data-testid={`${tid}-kota-provinsi`}>{barisBawah}</div>}
          </div>
          <button type="button" onClick={() => { onPilih(null); setQ(""); setHasil(null); }}
            className="text-xs font-semibold text-stone-600 underline shrink-0" data-testid={`${tid}-ganti`}>
            Ganti
          </button>
        </div>
      ) : (
        <>
          <div className="relative">
            <input value={q} onChange={(e) => setQ(e.target.value)}
              onFocus={() => setBuka(true)}
              onBlur={() => { if (q.trim() && onSentuh) onSentuh(); }}
              placeholder="Ketik kelurahan + kecamatan, cth: Kamal Kalideres"
              className="w-full mt-1 rounded-lg border border-stone-300 px-3 py-2 text-sm"
              data-testid={`${tid}-input`} />
            {memuat && <Loader2 size={16} className="absolute right-3 top-3.5 animate-spin text-stone-400" />}
          </div>
          {buka && hasil && (
            <div className="mt-1 max-h-[22rem] overflow-y-auto rounded-lg border border-stone-200 bg-white"
              data-testid={`${tid}-hasil`}>
              {hasil.length === 0 ? (
                <div className="px-3 py-2 text-sm text-stone-500">Wilayah tidak ditemukan. Coba kata lain.</div>
              ) : hasil.map((w) => (
                <button key={`${w.kecamatan_id}-${w.kelurahan_id}`} type="button"
                  onClick={() => { onPilih(w); setBuka(false); setQ(""); setHasil(null); }}
                  className="flex w-full items-start gap-2 px-3 py-2 text-left text-sm hover:bg-stone-50"
                  data-testid={`${tid}-opsi-${w.kecamatan_id}-${w.kelurahan_id}`}>
                  <MapPin size={14} className="mt-0.5 shrink-0 text-stone-400" />
                  <span className="flex-1">{w.label}</span>
                </button>
              ))}
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default WilayahPicker;
